import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';

import { enableBatching } from 'redux-batched-actions';
import rootReducer from './reducers';

const middlewares = [];

if (process.env.NODE_ENV === 'development') {
	const { logger } = require('redux-logger');
	middlewares.push(logger);
}

export default (initialState) => {
	const store = createStore(
		enableBatching(rootReducer),
		initialState,
		composeWithDevTools(applyMiddleware(...middlewares)),
	);

	if (module.hot) {
		module.hot.accept('./reducers', () => {
			const nextRootReducer = require('./reducers').default;
			store.replaceReducer(nextRootReducer);
		});
	}

	return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js